import React from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { TextLines } from './BaseText.types';

export const isSafeTextChild = (textChild: React.ReactNode) => {
  return typeof textChild === 'string' || typeof textChild === 'number' || React.isValidElement(textChild);
};

export const parseTextLines = (
  lines: string[],
  conversionStyleMap: Record<string, StyleProp<TextStyle>>,
  conversionKeys: { BOLD: string; ITALIC: string }
): TextLines => {
  return lines
    .map(line => {
      return line
        .split(new RegExp(`<${conversionKeys.BOLD}>|<${conversionKeys.ITALIC}>`))
        .map(part => {
          if (part.includes(`</${conversionKeys.BOLD}>`)) {
            return parseLine(part, conversionKeys.BOLD, conversionStyleMap);
          } else if (part.includes(`</${conversionKeys.ITALIC}>`)) {
            return parseLine(part, conversionKeys.ITALIC, conversionStyleMap);
          } else {
            return parseLine(part);
          }
        })
        .flat();
    })
    .flat()
    .filter(part => part.text.length > 0);
};

const parseLine = (
  line: string,
  separator?: string,
  conversionStyleMap?: Record<string, StyleProp<TextStyle>>
): TextLines => {
  if (!!separator && !!conversionStyleMap) {
    const [firstPart, secondPart] = line.split(`</${separator}>`);
    const result: TextLines = [
      {
        text: firstPart,
        textStyle: conversionStyleMap[separator],
      },
    ];
    if (!!secondPart) {
      result.push({
        text: secondPart,
      });
    }
    return result;
  } else {
    return [{ text: line }];
  }
};
